// Check if browser has support for input type date
// https://stackoverflow.com/questions/10193294/how-can-i-tell-if-a-browser-supports-input-type-date
const input = document.createElement('input');
input.setAttribute('type', 'date');

const notADateValue = 'not-a-date';
input.setAttribute('value', notADateValue);

export default input.value !== notADateValue;
